import type { CanvasJSONLikeObject } from '@doer/frontend-components/creativity-editor';
import { PILL_CHAIN_GAP, PILL_CHAIN_PADDING_LEFT } from '../../beneficios/data/chain-geometry';

export interface PillChainOpts {
  /** Optional pieceId for the wrapping Group. Required if the polymorphic binder needs to mount/unmount it. */
  groupPieceId?: string;
  position: { left: number; top: number; width: number; height: number };
  /** Base pill (left side of the chain). Caller supplies the full IText spec. */
  leftPill: CanvasJSONLikeObject;
  /** Pill attached to the right of `leftPill`. Helper wires `attachTo` + chain `paddingLeft`. */
  rightPill: CanvasJSONLikeObject;
}

export function buildPillChain(opts: PillChainOpts): CanvasJSONLikeObject {
  const { groupPieceId, position, leftPill, rightPill } = opts;

  const leftPieceId = leftPill.pieceId as string;
  const wiredRightPill: CanvasJSONLikeObject = {
    ...rightPill,
    attachTo: { pieceId: leftPieceId, side: 'right', gap: PILL_CHAIN_GAP },
    pill: { ...(rightPill.pill as Record<string, unknown>), paddingLeft: PILL_CHAIN_PADDING_LEFT }
  };

  return {
    ...(groupPieceId ? { pieceId: groupPieceId } : {}),
    type: 'Group',
    version: '7.1.0',
    originX: 'center',
    originY: 'center',
    left: position.left,
    top: position.top,
    width: position.width,
    height: position.height,
    objectCaching: false,
    subTargetCheck: true,
    interactive: false,
    selectable: true,
    evented: true,
    layoutManager: { type: 'layoutManager', strategy: 'fixed' },
    objects: [wiredRightPill, leftPill]
  };
}
